import Shimmer from '../customUtils/Components/Shimmer'
import { getReactionAsset } from './utils/reactionAssets'
import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react'
import { View, Text, StyleSheet, TextInput, TouchableOpacity, Keyboard, Image, ActivityIndicator, Platform, Animated, Modal } from 'react-native'
import { Feather, AntDesign, Ionicons } from '@expo/vector-icons'
import theme from '../../../theme'
import HeaderPosts from './HeaderPosts'
import InteractionsPosts from './InteractionsPosts'
import DescriptionPosts from './DescriptionPosts'
import CommentsPosts, { ReplyInput } from './CommentsPosts'
import ButtonCTA from './components/ButtonCTA'
import MediaComponent from '../customUtils/Components/MediaComponent'
import { apiUrl, apiUrlWSocket } from '../../config/config'
// import { fetchAuthSession } from 'aws-amplify/auth'
import { getAuthToken } from '../../utils/functions.utils'
import { Go_to } from './Go_to'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import { useRightSidebar } from '../web/context/RightSidebarContext'
import ModalComments from '../modals/ModalComments'
import PostWithComments from './PostWithComments'
import { FlatList } from 'react-native-gesture-handler'
import styles from './ItemDefaultStyles'
import SizeCache from '../../utils/sizeCache'
import { Loader } from '../customUtils/Components/Loader'
import { TrackingServices } from '../../../database/tracking.database'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { StatusBar } from 'react-native'
import { getConection } from '../appBar/context/HeaderContext'
import { getAlert } from '../appBar/context/AlertsContext'
import Constants from 'expo-constants'
import { debug, info, warn, error as logError, lazy } from '../../utils/logger'
import { enqueue, createAction, subscribeFlushOnReconnect } from '../../services/offline/offlineQueue'
import { useBreakpoint } from '@/redux/zustand/useDimensionStore'

// Componente de reacción individual con animación
const ReactionButton = ({ reaction, onPress }) => {
    const [isHovered, setIsHovered] = useState(false)
    const scaleAnim = useRef(new Animated.Value(1)).current

    useEffect(() => {
        Animated.spring(scaleAnim, {
            toValue: isHovered ? 1.3 : 1,
            friction: 4,
            tension: 200,
            useNativeDriver: true,
        }).start()
    }, [isHovered])

    return (
        <TouchableOpacity
            onPress={onPress}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
                alignItems: 'center',
                gap: 4,
                padding: 8,
                borderRadius: 12,
                backgroundColor: isHovered ? 'rgba(0, 0, 0, 0.05)' : 'transparent',
            }}
        >
            <Animated.View style={{ transform: [{ scale: scaleAnim }] }}>
                {(() => {
                    const imagePath = getReactionAsset(reaction.name)
                    return (
                        <Image
                            source={imagePath}
                            style={{
                                width: 40,
                                height: 40,
                            }}
                            onError={() => error('Reactions', 'Failed to load image for', reaction.name)}
                        />
                    )
                })()}
            </Animated.View>
            <Text
                style={{
                    fontSize: 11,
                    fontWeight: '600',
                    color: isHovered ? theme.colors.colorPrimary : '#666',
                    marginTop: 2,
                }}
            >
                {reaction.count || 0}
            </Text>
        </TouchableOpacity>
    )
}

export const CommentsModal = ({ handleSendComment, handlePresentModal, postId, handleSendCommentLikes, tokenUser, updateCounter, updateSnap }) => {
    const [text, setText] = useState('')
    const [commentId, setCommentId] = useState()
    const [userToSend, setUserToSend] = useState()
    const inputRef = useRef(null)
    const apiEndpointComment = `${apiUrl}/get_comment_wall`

    const [replies_response, setRepliesResponse] = useState([])
    const [allComments, setAllComments] = useState([])
    const [displayedComments, setDisplayedComments] = useState([])
    const [loading, setloading] = useState(false)
    const [loadingMore, setLoadingMore] = useState(false)
    const [viewLoading, setViewLoading] = useState(true)
    const [page, setPage] = useState(0)
    const [nextFetch, setNextFetch] = useState(true)
    const [stopSearching, setStopSearching] = useState(false)
    const flatListRef = useRef(null)

    const handleTextChange = (newText) => {
        setText(newText)
    }
    const { languageFile } = getLanguage()
    useEffect(() => {
        fetchComments(0).finally(() => {
            setViewLoading(false)
        })
    }, [])
    const handleTextChangeReply = (name_user, comment_id) => {
        if (comment_id) {
            setUserToSend(name_user)
            setText(name_user)
            setCommentId(comment_id)
        } else {
            setUserToSend()
            setText('')
            setCommentId()
            debug('Comments', 'dismiss reply')
            Keyboard.dismiss()
        }
    }

    const handleLike = async (comment_id, father_id) => {
        let res_comments_likes = await handleSendCommentLikes(comment_id, father_id)
        if (father_id) {
            return res_comments_likes
        } else {
            const updatedCommentsLikes = displayedComments.map((comment) => {
                if (comment._id == comment_id) {
                    const updatedLikes = res_comments_likes.update?.counter
                    const updatedComment = {
                        ...comment,
                        likes_count: updatedLikes,
                        isSelected: res_comments_likes.update?.status_like ? true : false,
                    }
                    return updatedComment
                }
                return comment
            })

            setDisplayedComments(updatedCommentsLikes)
            return res_comments_likes
        }
    }

    const handleTextandCloseChange = async (newText) => {
        if (newText.trim() === '' || newText == null) {
            return
        }
        setloading(true)
        try {
            let idComment = commentId
            if (!newText.startsWith('@')) {
                idComment = undefined
            }
            debug('Comments', 'sending comment with parent id', idComment)
            let res_comments = await handleSendComment(newText, idComment)
            flatListRef.current?.scrollToOffset({ animated: true, offset: 0 })
            TrackingServices.addTracking(postId, 'add_comment', 'post_comments')
            // log suprimido
            if (idComment) {
                debug('Comments', 'reply flow - updating replies_response')
                setRepliesResponse([{ comments: res_comments, comment_id: commentId }])
            } else {
                setDisplayedComments(res_comments)
            }
            setText('')
            setUserToSend()
            setText('')
            setCommentId()

            Keyboard.dismiss()
        } catch (error) {
            logError('Comments', 'Error al enviar el comentario', error)
        }
        setloading(false)
    }
    const fetchComments = async () => {
        try {
            if (tokenUser && postId) {
                const response = await fetch(apiEndpointComment, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: tokenUser,
                        post_id: postId,
                        page: page,
                    },
                })

                const data = await response.json()
                if (data['status'] === 1 && data['single'] && data['single']['comments'].length > 0) {
                    // * me llegan 20 comentarios cada vez que le pego a la api
                    // * en la app quiero mostrar solamente 10 comentarios
                    // * al llegar al final de los comentarios, muestro los siguientes 10 y hago otro fetch para traer otros 20
                    // * asi sucesivamente

                    const newComments = data['single']['comments']
                    setAllComments((prevComments) => [...prevComments, ...newComments])
                    setDisplayedComments((prevComments) => [...prevComments, ...newComments.slice(0, 10)])
                    setPage((prevPage) => prevPage + 1)
                } else {
                    // si no tengo mas coments seteo un state para que no me haga mas fetch
                    setNextFetch(false)
                }
            }
        } catch (error) {
            logError('Comments', 'Error en la solicitud de comments', error)
        }
    }

    const handleEndReached = () => {
        if (stopSearching) return
        if (viewLoading || loadingMore || allComments.length === 0 || displayedComments.length === 0) return
        setLoadingMore(true)
        try {
            const nextComments = allComments.slice(displayedComments.length, displayedComments.length + 10)
            if (nextComments.length === 0) {
                setLoadingMore(false)
                setStopSearching(true)
                return
            }
            setDisplayedComments((prevComments) => [...prevComments, ...nextComments])
            if (nextComments.length < 10 && nextFetch) {
                fetchComments(page)
            }
        } catch (error) {
            logError('Comments', 'Error en la solicitud de comments', error)
        } finally {
            setTimeout(() => {
                setLoadingMore(false)
            }, 5000)
        }
    }

    const handleSendCommentScroll = () => {}

    return (
        <>
            {viewLoading ? (
                <Loader />
            ) : (
                <View style={styles.container}>
                    {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}
                    {Platform.OS != 'web' && <Text style={styles.title}>{languageFile.comments}</Text>}
                    {displayedComments.length != 0 ? (
                        <View style={styles.commentsBlock}>
                            <FlatList
                                ref={flatListRef}
                                data={displayedComments}
                                horizontal={false}
                                showsVerticalScrollIndicator={false}
                                renderItem={({ item: comment }) => (
                                    <ModalComments
                                        key={comment._id}
                                        comment={comment}
                                        onReply={handleTextChangeReply}
                                        handleLike={handleLike}
                                        inputRef={inputRef}
                                        replies_response={replies_response}
                                    />
                                )}
                                onEndReached={() => handleEndReached()}
                                onEndReachedThreshold={0.5}
                                ListFooterComponent={loadingMore ? <ActivityIndicator size='small' color={theme.colors.colorPrimary} /> : null}
                            />
                        </View>
                    ) : (
                        <>
                            <View style={styles.containerNoComments}>
                                <Image style={styles.imageNoComments} source={require('../../../assets/noComments.png')} />
                                <Text style={styles.titleNoComments}>{languageFile.first_comment}</Text>
                                <Text style={styles.descriptionNoComments}>{languageFile.no_comment}</Text>
                            </View>
                        </>
                    )}

                    <View>
                        {/*    {commentId && userToSend && (
                    <View style={styles.replyToContainer}>
                        <Text style={styles.replyToText}>Responder a {userToSend}</Text>
                        <TouchableOpacity style={styles.clearButton} onPress={() => handleTextChangeReply('')}>
                            <AntDesign name='close' size={18} color={theme.colors.textPrimary} />
                        </TouchableOpacity>
                    </View>
                )}
                */}
                        <View style={styles.inputBlock}>
                            <TextInput
                                style={styles.input}
                                onChangeText={handleTextChange}
                                value={text}
                                placeholder={languageFile.write_a_comment}
                                placeholderTextColor={theme.colors.mediumGray}
                                ref={inputRef}
                            />
                            {!loading ? (
                                <TouchableOpacity onPress={() => handleTextandCloseChange(text)}>
                                    <Feather name='send' size={24} color={theme.colors.colorPrimary} />
                                </TouchableOpacity>
                            ) : (
                                <ActivityIndicator color={theme.colors.colorPrimary} size={24} />
                            )}
                        </View>
                    </View>
                </View>
            )}
        </>
    )
}

export const CommentsModalByGoToNotifications = (post_id) => {
    const PARENT_COMMENT_ID = post_id.comment_id
    const POST_ID = post_id.post_id

    const [text, setText] = useState('')
    const [updatedComments, setupdatedComments] = useState([])
    const [commentId, setCommentId] = useState()
    const [userToSend, setUserToSend] = useState()
    const inputRef = useRef(null)
    const [replies_response, setRepliesResponse] = useState([])
    const [tokenUser, setTokenUser] = useState(null)
    const apiEndpointComment = `${apiUrl}/get_comment_wall`
    const [loader, setloader] = useState(true)
    const mainViewRef = useRef(null)

    const { languageFile } = getLanguage()

    const fetchComments = async () => {
        try {
            const authToken = await getAuthToken('comments_fetch')
            let data_comments = []

            setTokenUser(authToken)

            if (authToken && POST_ID) {
                const response = await fetch(apiEndpointComment, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: authToken,
                        post_id: POST_ID,
                    },
                })

                const data = await response.json()
                if (data['status'] === 1 && data['single'] && data['single']['comments'].length > 0) {
                    setupdatedComments(data['single']['comments'])
                    data_comments = data['single']['comments']
                }
            }
            setloader(false)
            setTimeout(() => {
                scrollToComment(PARENT_COMMENT_ID, data_comments)
            }, 150)
        } catch (error) {
            logError('Comments', 'Error en la solicitud de comments', error)
            setloader(false)
        } finally {
            setloader(false)
        }
    }

    const handleSendComment = async (text, comment_id = undefined) => {
        try {
            let headers = {
                'Content-Type': 'application/json',
                Authorization: tokenUser,
                post_id: POST_ID,
                // message: text,
            }
            const body = {
                message: text,
            }

            if (comment_id) {
                headers['parent_comment_id'] = comment_id
            }
            const response = await fetch(`${apiUrl}/add_comment_wall`, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(body),
            })

            if (!response.ok) {
                const errorResponse = await response.json()
                throw new Error(`Fallo al agregar el comentario. Código de estado: ${response.status}. Detalles: ${JSON.stringify(errorResponse)}`)
            }

            const data = await response.json()
            if (comment_id) {
                return data.single?.users_comments
            } else {
                if (data.single?.users_comments.length > 0) {
                    // setComments(data?.single?.users_comments)
                    setupdatedComments(data?.single?.users_comments)
                    return data.single?.users_comments
                }
            }
        } catch (error) {
            logError('Comments', 'Error al enviar el comentario (269)', error)
        }
    }

    const handleSendCommentLikes = async (comment_id, father_id) => {
        debug('Comments', 'comment_id last function', comment_id)
        try {
            let comments = updatedComments
            debug('Comments', 'comments updated len', comments?.length)
            let headers = {
                'Content-Type': 'application/json',
                Authorization: tokenUser,
                comment_id: comment_id,
                post_id: POST_ID,
            }

            const response = await fetch(`${apiUrl}/add_like_comment`, {
                method: 'POST',
                headers: headers,
            })

            if (!response.ok) {
                const errorResponse = await response.json()
                throw new Error(
                    `Fallo al agregar el add_like_comment. Código de estado: ${response.status}. Detalles: ${JSON.stringify(errorResponse)}`,
                )
            }

            const data = await response.json()
            // Actualizar el estado de comments
            if (father_id) {
            } else {
                // const updatedComments = comments.map((comment) => {
                //     if (comment._id == comment_id) {
                //         // Incrementar el contador de likes
                //         const updatedLikes = data?.single?.counter
                //         // Cambiar el estado isSelected a true
                //         const updatedComment = { ...comment, likes_count: updatedLikes, isSelected: data?.single?.status_like ? true : false }
                //         return updatedComment
                //     }
                //     return comment
                // })
                // setupdatedComments(updatedComments)
            }
            return {
                comment_id: comment_id,
                father_id: father_id,
                update: data.single,
            }
        } catch (error) {
            logError('Comments', 'Error al enviar add_like_comment', error)
        }
    }

    const handleTextChange = (newText) => {
        setText(newText)
    }

    const handleTextChangeReply = (name_user, comment_id) => {
        if (comment_id) {
            setUserToSend(name_user)
            setText(name_user)
            setCommentId(comment_id)
        } else {
            setUserToSend()
            setText('')
            setCommentId()
            Keyboard.dismiss()
        }
    }

    const handleLike = async (comment_id, father_id) => {
        debug('Comments', 'handle like start')
        let res_comments_likes = await handleSendCommentLikes(comment_id, father_id)
        debug('Comments', 'handle like response', res_comments_likes)
        // if (father_id) {
        //     // const updatedCommentsLikes = updatedComments.map((comment) => {
        //     //     if (comment._id == father_id) {
        //     //         const updatedReplies = comment.replies.map((reply) => {
        //     //             if (reply._id == comment_id) {
        //     //                 const updatedLikes = res_comments_likes?.update?.counter
        //     //                 const updatedReply = {
        //     //                     ...reply,
        //     //                     likes_count: updatedLikes,
        //     //                     isSelected: res_comments_likes.update?.status_like ? true : false,
        //     //                 }
        //     //                 return updatedReply
        //     //             }
        //     //             return reply
        //     //         })
        //     //         return { ...comment, replies: updatedReplies }
        //     //     }
        //     //     return comment
        //     // })
        //     // setupdatedComments(updatedCommentsLikes)
        //     console.log('Hijo')
        //     return res_comments_likes
        // } else {
        //     console.log('Padre')
        //     // const updatedCommentsLikes = updatedComments.map((comment) => {
        //     //     if (comment._id == comment_id) {
        //     //         const updatedLikes = res_comments_likes.update?.counter
        //     //         const updatedComment = {
        //     //             ...comment,
        //     //             likes_count: updatedLikes,
        //     //             isSelected: res_comments_likes.update?.status_like ? true : false,
        //     //         }
        //     //         return updatedComment
        //     //     }
        //     //     return comment
        //     // })
        //     // setupdatedComments(updatedCommentsLikes)

        // }
        return res_comments_likes
    }

    const handleTextandCloseChange = async (newText) => {
        if (newText.trim() === '' || newText == null) {
            return
        }
        try {
            let res_comments = await handleSendComment(newText, commentId)
            TrackingServices.addTracking(post_id, 'add_comment', 'post_comments')
            if (commentId) {
                setRepliesResponse([{ comments: res_comments, comment_id: commentId }])
            } else {
                setupdatedComments(res_comments)
            }
            setText('')
            setUserToSend()
            setText('')
            setCommentId()

            Keyboard.dismiss()
        } catch (error) {
            logError('Comments', 'Error al enviar el comentario (399)', error)
        }
    }

    const scrollToComment = (comment_id, data_comments) => {
        try {
            const newComments = data_comments
            const commentIndex = newComments.findIndex((comment) => comment._id.toString() === comment_id.toString())
            if (commentIndex !== -1) {
                mainViewRef.current.scrollToIndex({ index: commentIndex, animated: true })
            } else {
                warn('Comments', 'Comment not found')
            }
        } catch (err) {
            logError('Comments', 'scrollToComment error:', err)
        }
    }

    useEffect(() => {
        fetchComments()
    }, [PARENT_COMMENT_ID])

    return (
        <>
            {loader ? (
                <Loader />
            ) : (
                <View style={styles.container}>
                    <Text style={styles.title}>{languageFile.comments}</Text>
                    {updatedComments.length !== 0 ? (
                        <View style={styles.commentsBlock}>
                            <FlatList
                                data={updatedComments}
                                horizontal={false}
                                initialNumToRender={5}
                                maxToRenderPerBatch={5}
                                windowSize={3}
                                ref={mainViewRef}
                                showsVerticalScrollIndicator={false}
                                renderItem={({ item: comment }) => (
                                    <ModalComments
                                        comment={comment}
                                        onReply={handleTextChangeReply}
                                        handleLike={handleLike}
                                        inputRef={inputRef}
                                        replies_response={replies_response}
                                        // openResponse={true}
                                        comment_id={post_id.comment_id}
                                    />
                                )}
                                // onEndReached={handleEndReached}
                                onEndReachedThreshold={0.3}
                            />
                        </View>
                    ) : (
                        <>
                            <View style={styles.containerNoComments}>
                                <Image style={styles.imageNoComments} source={require('../../../assets/noComments.png')} />
                                <Text style={styles.titleNoComments}>{languageFile.first_comment}</Text>
                                <Text style={styles.descriptionNoComments}>{languageFile.no_comment}</Text>
                            </View>
                        </>
                    )}

                    <View>
                        <View style={styles.inputBlock}>
                            <TextInput
                                style={styles.input}
                                onChangeText={handleTextChange}
                                value={text}
                                placeholder={languageFile.write_a_comment}
                                placeholderTextColor={theme.colors.mediumGray}
                                ref={inputRef}
                            />
                            <TouchableOpacity onPress={() => handleTextandCloseChange(text)}>
                                <Feather name='send' size={24} color={theme.colors.colorPrimary} />
                            </TouchableOpacity>
                        </View>
                    </View>
                </View>
            )}
        </>
    )
}

const PostsItemDefaultBase = ({
    handleCompleteSurvey,
    reactions,
    shouldAutoPlay,
    isVisible,
    keyChange,
    interactionPost,
    updateInteractions,
    interactionsReady,
    onFirstMediaReady,
    listIndex,
    ...posts
}) => {
    // Debug: Log de props recibidos
    useEffect(() => {
        // Log específico para videos
        if (posts.medias?.some((m) => m.media_type === 'video')) {
            console.log('[ItemDefault] 🎥 VIDEO POST props updated:', {
                postId: posts._id,
                shouldAutoPlay,
                isVisible,
                hasVideo: true,
            })
        }
    }, [shouldAutoPlay, isVisible, posts._id])

    const [isLastPage, setIsLastPage] = useState(false)
    const apiEndpointComment = `${apiUrl}/get_comment_wall`
    const apiEndpointInteraction = `${apiUrl}/get_reactions_wall_according_id`
    const [comments, setComments] = useState([])
    const [tokenUser, setTokenUser] = useState(null)
    const { openBottomSheet, updateSnapPoints, closeBottomSheet } = useBottomSheet()
    const { openRightSidebar, updateSidebarData, activeRightSidebar, sidebarData } = useRightSidebar()
    const bottomSheetRef = useRef(null)
    const tokenRef = useRef(null)

    // Estado para el selector de reacciones en web
    const [showReactionPicker, setShowReactionPicker] = useState(false)
    const [showCommentsModal, setShowCommentsModal] = useState(false)
    const [isLongPressing, setIsLongPressing] = useState(false) // Para feedback visual
    const [isImageZooming, setIsImageZooming] = useState(false) // Para elevar zIndex durante zoom
    const longPressTimerRef = useRef(null)
    const lastDomToggleTimeRef = useRef(0)
    const progressStartTimerRef = useRef(null)
    const handleLikeClickRef = useRef(null) // Ref para almacenar la función de reacción
    const mediaWrapperRef = useRef(null) // Ref para el wrapper del media
    const progressAnim = useRef(new Animated.Value(0)).current // Animación de progreso

    // Estados para doble clic en media
    const [showHeartAnimation, setShowHeartAnimation] = useState(false)
    const [isLikeAnimation, setIsLikeAnimation] = useState(true) // true = like (rojo), false = dislike (blanco/roto)
    const heartScaleAnim = useRef(new Animated.Value(0)).current
    const heartOpacityAnim = useRef(new Animated.Value(0)).current
    const lastClickTimeRef = useRef(0)

    // No-op function para líneas de debug residuales
    const addDebugLog = () => {}

    // Combinar catálogo (reactions: definiciones de single.reactions) con interactions.reactions (contadores por post)
    const reactionsWithCounts = useMemo(() => {
        // Reducido: evitar spam de logs en cada render

        let defs = reactions || []
        if (!defs || defs.length === 0) {
            try {
                // fallback a caché web o global
                const webSrv = require('../../services/web/postsWebService')
                defs = webSrv.getCachedReactions?.() || (typeof window !== 'undefined' ? window.__globalReactions || [] : [])
            } catch {}
        }
        if (!defs || defs.length === 0) {
            warn('Reactions', '[ItemDefault] No defs available - using empty array')
            return []
        }

        // Filtrar reacciones inválidas antes de procesarlas
        const validReactions = (reactions || []).filter((r) => r && typeof r === 'object' && r.name && typeof r.name === 'string')
        if (validReactions.length !== (reactions || []).length) {
            warn('Reactions', '[ItemDefault] Filtered invalid reactions', {
                original: (reactions || []).length,
                valid: validReactions.length,
            })
        }

        // (omit sample log original)

        // 🔍 VERIFICAR si hay nombres con espacios o caracteres extraños
        validReactions.forEach((r) => {
            // Ya validado arriba, pero verificación adicional por seguridad
            if (!r.name || typeof r.name !== 'string') {
                warn('Reactions', '[ItemDefault] Invalid name', {
                    name: r.name,
                    type: typeof r.name,
                    _id: r._id,
                })
                return
            }

            const hasSpaces = r.name !== r.name.trim()
            const hasSpecialChars = /[^a-zA-Z0-9_-]/.test(r.name)
            if (hasSpaces || hasSpecialChars) {
                warn('Reactions', '[ItemDefault] Problematic name', {
                    name: `"${r.name}"`,
                    trimmed: r.name.trim(),
                    hasSpaces,
                    hasSpecialChars,
                    _id: r._id,
                })
            }
        })

        // ✅ Mantener exactamente el catálogo del backend (single.reactions). En caso de duplicados por nombre, conservar el primero.
        const seenNames = new Set()
        const uniqueReactions = defs.filter((reaction) => {
            const normalizedName = reaction.name?.trim().toLowerCase()
            if (seenNames.has(normalizedName)) return false
            seenNames.add(normalizedName)
            return true
        })

        // (omit sample log after dedupe)

        // Si no hay contadores aún, devolver catálogo con count=0
        if (!interactionPost || !interactionPost.reactions || interactionPost.reactions.length === 0) {
            // (omit log no per-post counts)
            return uniqueReactions.map((r) => ({ ...r, count: 0 }))
        }

        // (omit per-post counts len log)

        // Combinar: para cada reaction, buscar su count en interactionPost.reactions
        const combined = uniqueReactions.map((reaction) => {
            const reactionData = interactionPost.reactions.find((r) => {
                const rid = r?.reaction_id || r?._id
                return rid?.toString?.() === reaction?._id?.toString?.()
            })
            // (omit match sample log)
            return {
                ...reaction,
                count: Number(reactionData?.count) || 0,
            }
        })

        // (omit combined sample log)

        return combined
    }, [reactions, interactionPost?.reactions])

    // Monitor cuando reactions cambia
    useEffect(() => {
        // (omit reactions prop changed log)
    }, [reactions])

    const { isConnected, hasInternet } = getConection() // useEffect(() => {

    const { setAlert } = getAlert()

    const expoConfig = Constants.expoConfig || { slug: '' }

    const handlePageChange = (isLastPage) => {
        setIsLastPage(isLastPage)
    }

    const handleEndReached = () => {
        setIsLastPage(true)
    }

    const SurveyCompleted = () => {
        handleCompleteSurvey(posts?._id)
    }

    const fetchToken = async () => {
        if (tokenRef.current) return
        try {
            const authToken = await getAuthToken('item_default')
            if (authToken) {
                setTokenUser(authToken)
                tokenRef.current = authToken
            }
        } catch (error) {
            logError('Auth', 'Error getting token', error)
        }
    }

    // Suscribir flush offline una vez
    useEffect(() => {
        subscribeFlushOnReconnect()
    }, [])

    const handleSendComment = useCallback(
        async (text, comment_id = undefined) => {
            if (!isConnected || !hasInternet) {
                // Offline: encolar y actualizar contadores locales
                try {
                    await enqueue(createAction('comment', String(posts?._id), { message: text, parent_comment_id: comment_id || null }))
                    const newCount = (interactionPost?.comment_count || 0) + 1
                    const newInteraction = { ...interactionPost, comment_count: newCount }
                    updateInteractions(newInteraction)
                } catch {}
                return
            }
            try {
                const LIMIT_COMMENTS = 20
                let headers = {
                    'Content-Type': 'application/json',
                    Authorization: tokenUser,
                    post_id: posts?._id,
                    limit: LIMIT_COMMENTS,
                    // message: text,
                }

                const body = {
                    message: text,
                }
                if (comment_id) {
                    headers['parent_comment_id'] = comment_id
                }
                const response = await fetch(`${apiUrl}/add_comment_wall`, {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify(body),
                })

                if (!response.ok) {
                    const errorResponse = await response.json()
                    throw new Error(
                        `Fallo al agregar el comentario. Código de estado: ${response.status}. Detalles: ${JSON.stringify(errorResponse)}`,
                    )
                }

                const data = await response.json()
                if (comment_id) {
                    return data.single?.users_comments
                } else {
                    if (data.single?.users_comments.length > 0) {
                        let newInteraction = { ...interactionPost, comment_count: data.single?.users_comments.length ?? 0 }
                        updateInteractions(newInteraction)
                        setComments(data?.single?.users_comments)
                        return data.single?.users_comments
                    }
                }
            } catch (error) {
                logError('Comments', 'Error al enviar el comentario (579)', error)
            }
        },
        [tokenUser, posts._id, interactionPost, updateInteractions],
    )

    const handleSendCommentLikes = useCallback(
        async (comment_id, father_id) => {
            try {
                TrackingServices.addTracking(comment_id, 'add_like_comment', 'post_comment_likes')
                let headers = {
                    'Content-Type': 'application/json',
                    Authorization: tokenUser,
                    comment_id: comment_id,
                    post_id: posts._id,
                }

                const response = await fetch(`${apiUrl}/add_like_comment`, {
                    method: 'POST',
                    headers: headers,
                })
                debug('Comments', 'response', response)
                if (!response.ok) {
                    const errorResponse = await response.json()
                    throw new Error(
                        `Fallo al agregar el add_like_comment. Código de estado: ${response.status}. Detalles: ${JSON.stringify(errorResponse)}`,
                    )
                }

                const data = await response.json()
                // Actualizar el estado de comments
                // if (father_id) {
                //     // const updatedCommentsLikes = comments.map((comment) => {
                //     //     if (comment._id == father_id) {
                //     //         const updatedReplies = comment.replies.map((reply) => {
                //     //             if (reply._id == comment_id) {
                //     //                 const updatedLikes = data?.single?.counter
                //     //                 const updatedReply = {
                //     //                     ...reply,
                //     //                     likes_count: updatedLikes,
                //     //                     isSelected: data?.single?.status_like ? true : false,
                //     //                 }
                //     //                 return updatedReply
                //     //             }
                //     //             return reply
                //     //         })
                //     //         return { ...comment, replies: updatedReplies }
                //     //     }
                //     //     return comment
                //     // })
                //     // setComments(updatedCommentsLikes)
                // } else {
                //     const updatedComments = comments.map((comment) => {
                //         if (comment._id == comment_id) {
                //             // Incrementar el contador de likes
                //             const updatedLikes = data?.single?.counter
                //             // Cambiar el estado isSelected a true
                //             const updatedComment = { ...comment, likes_count: updatedLikes, isSelected: data?.single?.status_like ? true : false }
                //             return updatedComment
                //         }
                //         return comment
                //     })

                //     setComments(updatedComments)
                // }
                if (father_id) {
                    debug('Comments', 'return branch 1', { comment_id, hasSingle: !!data.single })
                    return {
                        comment_id: comment_id,
                        father_id: father_id,
                        update: data.single,
                    }
                } else {
                    debug('Comments', 'return branch 2', { comment_id, hasSingle: !!data.single })
                    if (data?.single?.status_like != null) {
                        let comment_first = { ...interactionPost.comment_first, isSelected: data.single.status_like === 1 ? true : false }
                        let newInteraction = { ...interactionPost, comment_first: comment_first }

                        updateInteractions(newInteraction)
                    }
                    return {
                        comment_id: comment_id,
                        father_id: '',
                        update: data.single,
                    }
                }
            } catch (error) {
                logError('Comments', 'Error al enviar add_like_comment', error)
            }
        },
        [tokenUser, posts._id, interactionPost, updateInteractions],
    )

    // Handlers para long press en web (mostrar reacciones)
    const handleMediaPressIn = useCallback((e) => {
        if (Platform.OS !== 'web') return

        debug('Reactions', '[ItemDefault] Mouse down - starting long press timer')

        // Prevenir comportamientos por defecto
        if (e && e.preventDefault) {
            e.preventDefault()
        }
        if (e && e.stopPropagation) {
            e.stopPropagation()
        }

        longPressTimerRef.current = setTimeout(() => {
            debug('Reactions', '[ItemDefault] Long press COMPLETED - showing reaction picker')
            setShowReactionPicker(true)
        }, 1000) // 1 segundo
    }, [])

    const handleMediaPressOut = useCallback((e) => {
        if (Platform.OS !== 'web') return

        debug('Reactions', '[ItemDefault] Mouse up/leave - clearing timer')

        // Prevenir comportamientos por defecto
        if (e && e.preventDefault) {
            e.preventDefault()
        }
        if (e && e.stopPropagation) {
            e.stopPropagation()
        }

        if (longPressTimerRef.current) {
            clearTimeout(longPressTimerRef.current)
            longPressTimerRef.current = null
            debug('Reactions', '[ItemDefault] Timer cleared')
        }
    }, [])

    // Handler para cuando se selecciona una reacción desde el picker
    const handleReactionSelect = useCallback(async (reactionId) => {
        setShowReactionPicker(false)

        // Llamar a la función de InteractionsPosts si está disponible
        if (handleLikeClickRef.current) {
            try {
                await handleLikeClickRef.current(reactionId)
            } catch (error) {
                logError('Reactions', '[ItemDefault] Error handling reaction', error)
            }
        }
    }, [])

    // Limpiar timer al desmontar
    useEffect(() => {
        return () => {
            if (longPressTimerRef.current) {
                clearTimeout(longPressTimerRef.current)
            }
        }
    }, [])

    const isDisabledInteractionPress = (post) => {
        if (!post) return false

        const disabledInteractionTypes = ['survey']

        if (post.medias && post.medias.length > 0) {
            const hasDisabledType = post.medias.some((media) => {
                const mediaType = (media.media_type || '').toLowerCase()
                return disabledInteractionTypes.includes(mediaType)
            })
            if (hasDisabledType) return true
        }
        return false
    }

    // Configurar eventos nativos del DOM en web para long press
    useEffect(() => {
        if (Platform.OS !== 'web') return

        if (!mediaWrapperRef.current) {
            const timer = setTimeout(() => {}, 100)
            return () => clearTimeout(timer)
        }

        const element = mediaWrapperRef.current

        const handleMouseDown = (e) => {
            const interactionDisabled = isDisabledInteractionPress(posts)
            if (interactionDisabled == true) {
                return
            }

            const t = e && e.target
            // Ignorar clicks sobre el <video> o controles del player (data-role="player-control")
            if (t && t.closest && t.closest('[data-role="player-control"]')) return
            // No detener propagación: permitir que el player procese el click (play/pause)

            // Demora corta antes de mostrar el overlay de progreso para evitar flashes en taps rápidos
            if (progressStartTimerRef.current) clearTimeout(progressStartTimerRef.current)
            progressStartTimerRef.current = setTimeout(() => {
                setIsLongPressing(true)
                Animated.timing(progressAnim, {
                    toValue: 1,
                    duration: 1000,
                    useNativeDriver: false,
                }).start()
            }, 220)

            // Timer de 1s para abrir picker
            if (longPressTimerRef.current) clearTimeout(longPressTimerRef.current)
            longPressTimerRef.current = setTimeout(() => {
                setShowReactionPicker(true)
                setIsLongPressing(false)
                progressAnim.setValue(0)
            }, 1000)
        }

        const handleMouseUp = (e) => {
            const t = e && e.target
            if (t && t.closest && t.closest('[data-role="player-control"]')) return
            if (progressStartTimerRef.current) {
                clearTimeout(progressStartTimerRef.current)
                progressStartTimerRef.current = null
            }
            progressAnim.setValue(0)
            setIsLongPressing(false)
            if (longPressTimerRef.current) {
                clearTimeout(longPressTimerRef.current)
                longPressTimerRef.current = null
            }
        }

        const handleMouseLeave = (e) => {
            if (longPressTimerRef.current) {
                progressAnim.setValue(0)
                setIsLongPressing(false)
                clearTimeout(longPressTimerRef.current)
                longPressTimerRef.current = null
            }
        }

        const handleContextMenu = (e) => {
            e.preventDefault()
        }

        // Helper robusto para reproducir cuando el video aún no está listo
        const tryPlayVideo = (videoEl) => {
            const attempt = () => {
                const p = videoEl.play()
                if (p && typeof p.catch === 'function') p.catch(() => {})
            }
            if (!videoEl) return
            // Si ya tiene datos suficientes, reproducir inmediato
            if (videoEl.readyState >= 2) {
                attempt()
                return
            }
            let cleaned = false
            const cleanup = () => {
                if (cleaned) return
                cleaned = true
                try {
                    videoEl.removeEventListener('canplay', onCanPlay)
                } catch {}
                try {
                    videoEl.removeEventListener('loadeddata', onCanPlay)
                } catch {}
            }
            const onCanPlay = () => {
                cleanup()
                attempt()
            }
            try {
                videoEl.addEventListener('canplay', onCanPlay, { once: true })
            } catch {
                try {
                    videoEl.addEventListener('canplay', onCanPlay)
                } catch {}
            }
            try {
                videoEl.addEventListener('loadeddata', onCanPlay, { once: true })
            } catch {
                try {
                    videoEl.addEventListener('loadeddata', onCanPlay)
                } catch {}
            }
            // Safety: reintento corto por si los eventos no disparan
            setTimeout(() => {
                if (!cleaned) {
                    cleanup()
                    attempt()
                }
            }, 350)
        }

        const handleClick = (e) => {
            const t = e && e.target
            if (t && t.closest && t.closest('[data-role="player-control"]')) {
                console.log('[handleClick] - Click on player-control, ignoring')
                return
            }

            console.log('[handleClick] - Click detected on media wrapper')
            const interactionDisabled = isDisabledInteractionPress(posts)
            if (interactionDisabled == true) {
                return
            }
            const now = Date.now()
            const timeSinceLastClick = now - lastClickTimeRef.current

            // Detectar doble clic (menos de 300ms entre clics)
            if (timeSinceLastClick < 300 && timeSinceLastClick > 0) {
                debug('Reactions', '[ItemDefault] Double click detected - triggering like animation')

                // Prevenir comportamiento por defecto (solo en el área general del media, no en controles del player)
                e.preventDefault()
                e.stopPropagation()

                // Helpers para like/heart equivalentes
                const isLikeReaction = (name) => name === 'like' || name === 'likee' || name === 'heart'

                // Verificar si el usuario ya tiene un like/heart específicamente
                const userHasAnyReaction = interactionPost?.user_reaction?.length > 0
                const currentReaction = interactionPost?.user_reaction?.[0]
                const userHasLike = userHasAnyReaction && isLikeReaction(currentReaction?.name)

                debug('Reactions', '[ItemDefault] like state', { userHasLike, userHasAnyReaction, hasCurrentReaction: !!currentReaction })

                // Lógica solicitada:
                // - Si ya tiene heart/like: hacer dislike (quitar like) y animación de dislike.
                // - Si tiene otra reacción: cambiar directamente a heart/like con animación positiva.
                // - Si no tiene reacción: agregar heart/like con animación positiva.

                const likeReaction = reactions?.find((r) => isLikeReaction(r.name))
                if (!likeReaction) {
                    warn('Reactions', '[ItemDefault] Like/heart reaction not found in catalog')
                }

                if (userHasLike) {
                    // Quitar like actual
                    setIsLikeAnimation(false)
                    if (handleLikeClickRef.current && currentReaction) {
                        handleLikeClickRef.current(currentReaction._id || currentReaction.reaction_id)
                    }
                } else {
                    // Cambiar/Agregar heart directamente
                    setIsLikeAnimation(true)
                    if (handleLikeClickRef.current && likeReaction) {
                        handleLikeClickRef.current(likeReaction._id || likeReaction.reaction_id)
                    }
                }

                // Mostrar animación del corazón
                setShowHeartAnimation(true)
                heartScaleAnim.setValue(0)
                heartOpacityAnim.setValue(1)

                Animated.parallel([
                    Animated.spring(heartScaleAnim, {
                        toValue: 1,
                        friction: 3,
                        tension: 40,
                        useNativeDriver: true,
                    }),
                    Animated.sequence([
                        Animated.delay(200),
                        Animated.timing(heartOpacityAnim, {
                            toValue: 0,
                            duration: 400,
                            useNativeDriver: true,
                        }),
                    ]),
                ]).start(() => {
                    setShowHeartAnimation(false)
                })

                lastClickTimeRef.current = 0 // Reset para evitar triple clic
            } else {
                // Single click: toggle play/pause como fallback directo del <video> en web
                lastClickTimeRef.current = now
                try {
                    const el = mediaWrapperRef.current
                    if (Platform.OS === 'web' && el && posts?.medias?.some((m) => (m.media_type || '').toLowerCase() === 'video')) {
                        if (now - (lastDomToggleTimeRef.current || 0) > 150) {
                            const videoEl = el.querySelector && el.querySelector('video')
                            if (videoEl) {
                                if (videoEl.paused) {
                                    tryPlayVideo(videoEl)
                                } else {
                                    videoEl.pause()
                                }
                                lastDomToggleTimeRef.current = now
                                // Evitar doble toggle por handlers del player/React
                                if (e && e.preventDefault) e.preventDefault()
                                if (e && e.stopPropagation) e.stopPropagation()
                            }
                        }
                    }
                } catch {}
            }
        }

        const handleDoubleClick = (e) => {
            const interactionDisabled = isDisabledInteractionPress(posts)
            if (interactionDisabled == true) {
                return
            }

            const t = e && e.target
            if (t && t.closest && t.closest('[data-role="player-control"]')) return
            // Prevenir comportamiento por defecto (solo en el área general del media)
            e.preventDefault()
            e.stopPropagation()
        }

        // Fallback adicional: también enganchar eventos directamente al <video> si existe
        let videoEl = null
        let handleVideoClick = null
        try {
            videoEl = element.querySelector && element.querySelector('video')
            if (videoEl) {
                handleVideoClick = (ev) => {
                    debug('Player', '[ItemDefault] click on <video> captured')
                    handleClick(ev)
                }
            }
        } catch {}

        // Usar addEventListener en el elemento del DOM directamente
        element.addEventListener('click', handleClick, true)
        element.addEventListener('dblclick', handleDoubleClick, true)
        element.addEventListener('mousedown', handleMouseDown, true)
        element.addEventListener('mouseup', handleMouseUp, true)
        element.addEventListener('mouseleave', handleMouseLeave, false)
        element.addEventListener('contextmenu', handleContextMenu, true)
        if (videoEl && handleVideoClick) {
            videoEl.addEventListener('click', handleVideoClick, true)
        }

        // Fallback final: capturar a nivel de documento y filtrar por el wrapper
        const handleDocumentClick = (ev) => {
            try {
                const t = ev && ev.target
                if (t && t.closest && t.closest('[data-role="player-control"]')) {
                    console.log('[handleDocumentClick] - Click on player-control, ignoring')
                    return
                }

                const interactionDisabled = isDisabledInteractionPress(posts)
                if (interactionDisabled == true) {
                    return
                }
                const path = ev.composedPath ? ev.composedPath() : []
                const inside = path.length ? path.includes(element) : element && element.contains && element.contains(ev.target)
                if (!inside) return
                debug('Player', '[ItemDefault] document click captured within wrapper')
                handleClick(ev)
            } catch {}
        }
        document.addEventListener('click', handleDocumentClick, true)

        return () => {
            element.removeEventListener('click', handleClick, true)
            element.removeEventListener('dblclick', handleDoubleClick, true)
            element.removeEventListener('mousedown', handleMouseDown, true)
            element.removeEventListener('mouseup', handleMouseUp, true)
            element.removeEventListener('mouseleave', handleMouseLeave, false)
            element.removeEventListener('contextmenu', handleContextMenu, true)
            if (videoEl && handleVideoClick) {
                try {
                    videoEl.removeEventListener('click', handleVideoClick, true)
                } catch {}
            }
            try {
                document.removeEventListener('click', handleDocumentClick, true)
            } catch {}
        }
    }, [posts._id])

    function handlePresentModal(e) {
        // Prevenir comportamiento por defecto en web
        if (!isConnected && !hasInternet) {
            setAlert('No puedes realizar esta acción sin conexión a internet', 'white', 'wifi-off', 'rgba(0, 0, 0, 0.8)')
            return
        }
        if (e && e.preventDefault) {
            e.preventDefault()
        }
        if (e && e.stopPropagation) {
            e.stopPropagation()
        }

        if (!isConnected || !hasInternet) {
            warn('Reactions', '[ItemDefault] No internet connection')
            return
        }

        debug('Comments', '[ItemDefault] Opening comments for post', posts._id)

        // En web, abrir el RightSidebar de comentarios (no modal bottom)
        if (Platform.OS === 'web') {
            try {
                const updatedPost = { ...posts, interactions: interactionPost }
                openRightSidebar?.('comments', {
                    post: updatedPost,
                    onPostUpdate: (updatedInteractions) => {
                        const newInter = { post_id: posts._id, ...interactionPost, ...updatedInteractions }
                        try {
                            updateInteractions(newInter)
                        } catch {}
                        try {
                            updateSidebarData?.({ post: { ...posts, interactions: newInter } })
                        } catch {}
                    },
                })
            } catch (error) {
                logError('Comments', '[ItemDefault] Error opening comments sidebar', error)
            }
            return
        }

        // En mobile, mantener modal overlay
        try {
            // setShowCommentsModal(true)
            if (isConnected && hasInternet) {
                const snapPoints = ['60%']
                const updatedPost = { ...posts, interactions: interactionPost }
                openBottomSheet(
                    <PostWithComments
                        post={updatedPost}
                        closeSheet={() => setShowCommentsModal(false)}
                        onPostUpdate={(updatedInteractions) => {
                            // merge y propagar
                            const newInter = { post_id: posts._id, ...interactionPost, ...updatedInteractions }
                            try {
                                updateInteractions(newInter)
                            } catch {}
                        }}
                        commentsOnly={true}
                    />,
                    snapPoints,
                    true,
                    true,
                    true,
                    'never',
                    true,
                )
            } else {
                setAlert('No puedes realizar esta acción sin conexión a internet', 'white', 'wifi-off', 'rgba(0, 0, 0, 0.8)')
            }
        } catch (error) {
            logError('Comments', '[ItemDefault] Error opening comments modal', error)
        }
    }

    useEffect(() => {
        fetchToken()
    }, [])
    const bp = useBreakpoint()
    const isMobile = bp === 'sm'
    return (
        <View key={posts.id} style={[styles.containerPost, !isMobile && { marginHorizontal: 0 }]}>
            <HeaderPosts
                avatar={posts.avatar}
                publisher={posts.publisher}
                labels={posts.labels}
                date={posts.publication_date}
                views={interactionPost && interactionPost?.views ? interactionPost?.views : '0'}
                views_local={posts.views}
                loadingInteractions={!interactionsReady}
            />

            {posts.medias && (
                <View style={{ position: 'relative', overflow: Platform.OS === 'web' ? 'hidden' : 'visible', zIndex: isImageZooming ? 99999 : 1 }}>
                    {/* Wrapper para capturar eventos de mouse en web */}
                    <View
                        ref={mediaWrapperRef}
                        style={{
                            position: 'relative',
                            userSelect: 'none',
                            WebkitUserSelect: 'none',
                            cursor: Platform.OS === 'web' ? 'pointer' : 'default',
                            overflow: Platform.OS === 'web' ? 'hidden' : 'visible',
                            zIndex: isImageZooming ? 99999 : 1,
                            // No forzamos minHeight en mobile para evitar espacios blancos
                            // El MediaComponent/VideoPlayerAV determinará la altura correcta
                        }}
                    >
                        <MediaComponent
                            medias={posts.medias}
                            onPageChange={handlePageChange}
                            onEndReached={handleEndReached}
                            handleCompleteSurvey={SurveyCompleted}
                            post_id={posts._id}
                            autoplay={Platform.OS !== 'web' ? !!shouldAutoPlay : false}
                            isVisible={isVisible}
                            contentSeen={() => {}}
                            path={'post'}
                            isGoTo={posts.go_to ? true : false}
                            isPost={true}
                            isPostPlayer={true}
                            onFirstMediaReady={onFirstMediaReady}
                            listIndex={listIndex}
                            onImageZoomChange={(isZooming) => setIsImageZooming(isZooming)}
                            onLongPressReaction={() => {
                                // En mobile, abrir selector de reacciones (reutilizamos el mismo flujo)
                                if (!isConnected && !hasInternet) {
                                    setAlert('No puedes realizar esta acción sin conexión a internet', 'white', 'wifi-off', 'rgba(0, 0, 0, 0.8)')
                                    return
                                }
                                setShowReactionPicker(true)
                            }}
                            onDoubleTapReaction={() => {
                                // En mobile, alternar like/dislike similar a web
                                if (!isConnected && !hasInternet) {
                                    setAlert('No puedes realizar esta acción sin conexión a internet', 'white', 'wifi-off', 'rgba(0, 0, 0, 0.8)')
                                    return
                                }
                                try {
                                    const userHasAnyReaction = interactionPost?.user_reaction?.length > 0
                                    const currentReaction = interactionPost?.user_reaction?.[0]
                                    const isLikeReaction = (name) => name === 'like' || name === 'likee' || name === 'heart'
                                    const likeReaction = reactions?.find((r) => isLikeReaction(r.name))

                                    if (userHasAnyReaction && isLikeReaction(currentReaction?.name)) {
                                        // Quitar like actual en mobile (dislike)
                                        setIsLikeAnimation(false)
                                        if (handleLikeClickRef.current && currentReaction) {
                                            handleLikeClickRef.current(currentReaction._id || currentReaction.reaction_id)
                                        }
                                    } else {
                                        // Cambiar/Agregar heart en un solo gesto (like)
                                        setIsLikeAnimation(true)
                                        if (handleLikeClickRef.current && likeReaction) {
                                            handleLikeClickRef.current(likeReaction._id || likeReaction.reaction_id)
                                        }
                                    }
                                    setShowHeartAnimation(true)
                                    heartScaleAnim.setValue(0)
                                    heartOpacityAnim.setValue(1)
                                    Animated.parallel([
                                        Animated.spring(heartScaleAnim, { toValue: 1, friction: 3, tension: 40, useNativeDriver: true }),
                                        Animated.sequence([
                                            Animated.delay(200),
                                            Animated.timing(heartOpacityAnim, { toValue: 0, duration: 400, useNativeDriver: true }),
                                        ]),
                                    ]).start(() => setShowHeartAnimation(false))
                                } catch {}
                            }}
                        />

                        {/* Overlay de feedback visual durante long press con barra de progreso */}
                        {Platform.OS === 'web' && isLongPressing && (
                            <View
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundColor: 'rgba(0, 0, 0, 0.1)',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    pointerEvents: 'none',
                                    // Asegurar que quede por detrás del botón de play (10001)
                                    zIndex: 9998,
                                }}
                            >
                                <View
                                    style={{
                                        backgroundColor: 'rgba(255, 255, 255, 0.95)',
                                        paddingHorizontal: 24,
                                        paddingVertical: 16,
                                        borderRadius: 20,
                                        minWidth: 200,
                                    }}
                                >
                                    <Text
                                        style={{
                                            fontSize: 14,
                                            color: '#333',
                                            marginBottom: 12,
                                            textAlign: 'center',
                                            fontWeight: '500',
                                        }}
                                    >
                                        Mantén presionado...
                                    </Text>
                                    {/* Barra de progreso */}
                                    <View
                                        style={{
                                            height: 4,
                                            backgroundColor: 'rgba(0, 122, 255, 0.2)',
                                            borderRadius: 2,
                                            overflow: 'hidden',
                                        }}
                                    >
                                        <Animated.View
                                            style={{
                                                height: 4,
                                                backgroundColor: '#007AFF',
                                                borderRadius: 2,
                                                width: progressAnim.interpolate({
                                                    inputRange: [0, 1],
                                                    outputRange: ['0%', '100%'],
                                                }),
                                            }}
                                        />
                                    </View>
                                </View>
                            </View>
                        )}

                        {/* Animación del corazón al hacer doble clic */}
                        {Platform.OS === 'web' && showHeartAnimation && (
                            <View
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    pointerEvents: 'none',
                                }}
                            >
                                <Animated.View
                                    style={{
                                        transform: [{ scale: heartScaleAnim }],
                                        opacity: heartOpacityAnim,
                                        ...(isLikeAnimation
                                            ? {}
                                            : {
                                                  shadowColor: '#000',
                                                  shadowOffset: { width: 0, height: 2 },
                                                  shadowOpacity: 0.8,
                                                  shadowRadius: 3,
                                              }),
                                    }}
                                >
                                    <Ionicons
                                        name={isLikeAnimation ? 'heart' : 'heart-dislike-outline'}
                                        size={100}
                                        color={isLikeAnimation ? '#FF3B30' : '#FFFFFF'}
                                        style={
                                            isLikeAnimation
                                                ? {}
                                                : {
                                                      textShadowColor: 'rgba(0, 0, 0, 0.75)',
                                                      textShadowOffset: { width: 0, height: 2 },
                                                      textShadowRadius: 5,
                                                  }
                                        }
                                    />
                                </Animated.View>
                            </View>
                        )}
                    </View>

                    {/* Selector de reacciones (solo web) */}
                    {Platform.OS === 'web' && showReactionPicker && (
                        <View
                            style={{
                                position: 'absolute',
                                bottom: 20,
                                left: 0,
                                right: 0,
                                alignItems: 'center',
                                justifyContent: 'center',
                                zIndex: 50,
                                pointerEvents: 'box-none',
                            }}
                            onMouseEnter={() => {
                                debug('Reactions', '[Picker] Mouse enter - reactionsWithCounts', reactionsWithCounts?.length)
                                if (showReactionPicker) {
                                    // Mouse entered picker
                                }
                            }}
                            onMouseLeave={() => {
                                debug('Reactions', '[Picker] Mouse leave - closing picker')
                                setShowReactionPicker(false)
                            }}
                        >
                            <View
                                style={{
                                    backgroundColor: 'rgba(255, 255, 255, 0.98)',
                                    borderRadius: 50,
                                    paddingHorizontal: 16,
                                    paddingVertical: 10,
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    gap: 8,
                                    shadowColor: '#000',
                                    shadowOffset: { width: 0, height: 4 },
                                    shadowOpacity: 0.3,
                                    shadowRadius: 12,
                                    elevation: 8,
                                    pointerEvents: 'auto',
                                }}
                            >
                                {(() => {
                                    debug('Reactions', '[Picker] rendering - len', reactionsWithCounts?.length)
                                    return (
                                        reactionsWithCounts &&
                                        reactionsWithCounts.length > 0 &&
                                        reactionsWithCounts.map((reaction, idx) => {
                                            debug('Reactions', 'ReactionButton rendering', { name: reaction.name, count: reaction.count })

                                            return (
                                                <ReactionButton
                                                    key={reaction._id || idx}
                                                    reaction={reaction}
                                                    onPress={() => handleReactionSelect(reaction._id)}
                                                />
                                            )
                                        })
                                    )
                                })()}
                            </View>
                        </View>
                    )}
                </View>
            )}

            {posts.go_to?.text && <Go_to go_to={posts.go_to} />}

            {/* CTA nueva (cta_button) o legacy (text_link_share/link_share) */}
            {posts?.cta_button ? (
                <ButtonCTA posts={posts} url={posts.cta_button.url} text={posts.cta_button.text} style_type={posts.cta_button.style_type} />
            ) : (
                posts.text_link_share && <ButtonCTA posts={posts} />
            )}

            {/* Interacciones siempre van abajo, independiente del tipo de media */}
            {interactionsReady ? (
                <InteractionsPosts
                    posts={posts}
                    onCommentClick={handlePresentModal}
                    comments_counter={interactionPost && interactionPost?.comment_count ? interactionPost?.comment_count : 0}
                    reactions={reactions}
                    favourite={posts.status_favourite}
                    interactions={interactionPost}
                    isGoTo={posts.go_to && posts.medias.length > 1 ? true : false}
                    updateInteractions={(newInteractions) => {
                        try {
                            updateInteractions(newInteractions)
                        } catch {}
                        try {
                            if (
                                Platform.OS === 'web' &&
                                activeRightSidebar === 'comments' &&
                                sidebarData?.post?._id?.toString?.() === posts?._id?.toString?.() &&
                                typeof updateSidebarData === 'function'
                            ) {
                                const updatedPost = { ...posts, interactions: newInteractions }
                                updateSidebarData({ post: updatedPost })
                            }
                        } catch {}
                    }}
                    onReactionPickerRef={handleLikeClickRef}
                    showReactionPicker={showReactionPicker}
                    setShowReactionPicker={setShowReactionPicker}
                />
            ) : (
                <View style={{ paddingHorizontal: 12, paddingTop: 6 }}>
                    <Shimmer style={{ height: 28, borderRadius: 8, marginVertical: 6 }} />
                </View>
            )}

            {/* Descripción del post */}
            <DescriptionPosts posts={posts} />

            {/* Modal de comentarios con overlay negro */}
            <Modal visible={showCommentsModal} transparent={true} animationType='fade' onRequestClose={() => setShowCommentsModal(false)}>
                <View
                    style={{
                        flex: 1,
                        backgroundColor: 'rgba(0,0,0,0.85)',
                        paddingTop: Platform.OS === 'web' ? 20 : 48,
                    }}
                >
                    {/* Botón cerrar */}
                    <TouchableOpacity
                        onPress={() => setShowCommentsModal(false)}
                        style={{ position: 'absolute', top: Platform.OS === 'web' ? 10 : 50, right: 14, zIndex: 1000, padding: 8 }}
                    >
                        <Ionicons name='close' size={28} color='#fff' />
                    </TouchableOpacity>

                    <View
                        style={{
                            flex: 1,
                            backgroundColor: 'white',
                            marginTop: 40,
                            borderTopLeftRadius: 16,
                            borderTopRightRadius: 16,
                            maxWidth: 582,
                            paddingTop: 5,
                            overflow: 'hidden',
                        }}
                    >
                        {(() => {
                            const updatedPost = { ...posts, interactions: interactionPost }
                            return (
                                <PostWithComments
                                    post={updatedPost}
                                    closeSheet={() => setShowCommentsModal(false)}
                                    onPostUpdate={(updatedInteractions) => {
                                        // merge y propagar
                                        const newInter = { post_id: posts._id, ...interactionPost, ...updatedInteractions }
                                        try {
                                            updateInteractions(newInter)
                                        } catch {}
                                    }}
                                    commentsOnly={true}
                                />
                            )
                        })()}
                    </View>
                </View>
            </Modal>
            {expoConfig.slug != 'one-pfizer' &&
                (interactionsReady ? (
                    <CommentsPosts
                        posts={posts}
                        onCommentClick={handlePresentModal}
                        allComments={comments}
                        handleSendCommentLikes={handleSendCommentLikes}
                        firstComment={interactionPost && interactionPost?.comment_first ? interactionPost?.comment_first : {}}
                        commentCount={
                            interactionPost && (interactionPost?.comments_counter || interactionPost?.comment_count)
                                ? interactionPost?.comments_counter || interactionPost?.comment_count
                                : '0'
                        }
                    />
                ) : (
                    <View style={{ paddingHorizontal: 12 }}>
                        <Shimmer style={{ height: 14, width: '65%', borderRadius: 6, marginTop: 6 }} />
                        <View style={{ height: 10 }} />
                    </View>
                ))}
        </View>
    )
}

export const PostsItemDefault = React.memo(PostsItemDefaultBase, (prev, next) => {
    // Re-render solo si cambia id, visibilidad, autoplay o catálogo de reacciones (longitud)
    const prevId = prev.posts?._id || prev._id
    const nextId = next.posts?._id || next._id
    if (prevId !== nextId) return false

    if (prev.shouldAutoPlay !== next.shouldAutoPlay) return false
    if (prev.isVisible !== next.isVisible) return false

    const prevLen = Array.isArray(prev.reactions) ? prev.reactions.length : 0
    const nextLen = Array.isArray(next.reactions) ? next.reactions.length : 0
    if (prevLen !== nextLen) return false

    // Re-render si cambian las interacciones (incluye views, comments, reactions, etc.)
    const prevInter = prev.interactionPost
    const nextInter = next.interactionPost

    // Si antes no había interacción y ahora sí (o viceversa), re-render
    if (!prevInter && nextInter) return false
    if (prevInter && !nextInter) return false

     if (prevInter && nextInter) {
        // Comparar los campos relevantes (evitar stringify full si te preocupa rendimiento)
        if (prevInter.views !== nextInter.views) return false
        if (prevInter.comment_count !== nextInter.comment_count) return false

        const prevUserReactionId = prevInter.user_reaction?.[0]?.reaction_id || prevInter.user_reaction?.[0]?._id
        const nextUserReactionId = nextInter.user_reaction?.[0]?.reaction_id || nextInter.user_reaction?.[0]?._id
        if (prevUserReactionId !== nextUserReactionId) return false

        // Comparar comment_first para sincronizar likes del primer comentario
        const prevFirstComment = prevInter.comment_first
        const nextFirstComment = nextInter.comment_first
        
        if (prevFirstComment?._id !== nextFirstComment?._id) {
            return false
        }
        if (prevFirstComment?.isSelected !== nextFirstComment?.isSelected) {
            return false
        }
        if (prevFirstComment?.likes_count !== nextFirstComment?.likes_count) {
            return false
        }
    }

    return true
})
